import styles from './styles/duplicatesPopup.module.scss';
import { data } from './data';
import { ajax } from './ajax';
import { isNotNullOrUndef } from '../../js/helpers/isNotNullOrUndef';
const vn = window.vNode;
const isEqualItems = (item1, item2) => {
    if (item1.key !== item2.key && item1.variant_id !== item2.variant_id)
        return false;
    if (isNotNullOrUndef(item1.properties) && isNotNullOrUndef(item2.properties)) {
        if (Object.keys(item1.properties).some(key => item1.properties[key] !== item2.properties[key]))
            return false;
    }
    return true;
};
export const duplicatesPopup = (mainItem, duplicateLines) => {
    const popup = vn.create('div', {
        class: `${styles.popup} pos:f t:0 l:0 r:0 b:0`
    }, [
        vn.create('div', { class: `${styles.message} text:center` }, [
            vn.create('h4', { class: `${styles.title} fw:700` }, [
                vn.create('s-svg', { 'data-icon': '#icon--error', style: 'aspect-ratio: 28 / 26' }),
                vn.create('strong', [' NOTE:']),
                ' THIS ARTWORK IS ALREADY IN YOUR CART'
            ]),
            vn.create('p', { class: styles.question }, ['Keep only this item and remove other variations of this item?']),
            vn.create('button', {
                class: `${styles.buttonYes} fw:700 d:block m:auto`,
                'data-ga-event': '["Duplicate alert", "Click", "Duplicate alert- Yes"]',
                events: {
                    click: () => {
                        const updateArr = [];
                        data.items.forEach((dataItem, lineNumber) => {
                            if (duplicateLines.includes(lineNumber)) {
                                updateArr.push(0);
                            }
                            else if (isEqualItems(mainItem, dataItem)) {
                                updateArr.push(1);
                            }
                            else {
                                updateArr.push(dataItem.quantity);
                            }
                        });
                        ajax.updateCart(updateArr);
                        vn.unmount(popup);
                    }
                }
            }, ['YES']),
            vn.create('button', {
                class: `${styles.buttonNo} fw:400`,
                'data-ga-event': '["Duplicate alert", "Click", "Duplicate alert- No"]',
                events: {
                    click: () => {
                        vn.unmount(popup);
                    }
                }
            }, ['No, I want them all'])
        ])
    ]);
    vn.mount({ vNode: popup, container: document.body });
};
